var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"calendar"},_vm._l((_vm.timeSlots),function(slot,index){return _c('div',{key:index,class:['day-card', { selected: _vm.selectedTime === slot.value }],on:{"click":function($event){return _vm.selectTime(slot)}}},[_c('div',{staticClass:"day-name"},[_vm._v(_vm._s(slot.label))])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05d30b0f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalendarTime.vue
// module id = 633
// module chunks = 3